<div class="modal-dialog modal-lg" role="document">
  <div class="modal-content" >
    <div class="modal-header">
      <h5 class="modal-title modalTitle addClass" id="exampleModalLabel">{{ store_details ? 'Update':'Create'}} Store</h5>
      <img class="close" (click)="closeModal()" data-dismiss="modal" src="./assets/img/finance/cancel.png">
    </div>
    <div class="modal-body leadView" >
      <form class="viewProfileForm" [formGroup]="storeForm">
        <div class="row addClass">
          <div class="col-sm-12 col-md-6">
            <div class="form-group">
              <label>Store Name<span class="text-danger">*</span></label>
              <input type="text" class="form-control" placeholder="Enter store name" formControlName="name">
            </div>
          </div>
          <div class="col-sm-12 col-md-6">
            <div class="form-group">
              <label>Address<span class="text-danger">*</span></label>
              <input type="text" class="form-control" placeholder="Enter address" formControlName="address">
            </div>
          </div>
          <div class="col-sm-12 col-md-6">
            <div class="form-group">
              <label>Type<span class="text-danger">*</span></label>
              <ng-select  [multiple]="false"
              [closeOnSelect]="true"
              [searchable]="false" formControlName="stype" placeholder="Select Type" [compareWith]="compareFunction">
                <ng-option value="COCO">COCO</ng-option>
                <ng-option value="FOCO">FOCO</ng-option>
                <ng-option value="FOFO">FOFO</ng-option>
              </ng-select>             
            </div>
          </div>
          <div class="col-sm-12 col-md-6">
            <div class="form-group">
              <label>Commission<span class="text-danger">*</span></label>
              <div class="d-flex align-items-center">
                <input type="number" class="form-control" placeholder="Enter Commission (0% - 100%)" formControlName="commission" onKeyPress="if(this.value.length == 3) return false;">
                <span class="inputInfo border px-3">%</span>
              </div>
            </div>
          </div>
          <div class="col-sm-12 col-md-12">
            <button type="button" class="btn addCursor downloadBtn btn-pink pull-right" (click)="submitStoreDetails(storeForm.value)" *ngIf="!store_details" [disabled]="!storeForm.valid">Submit</button>
            <button type="button" class="btn addCursor downloadBtn btn-pink pull-right" (click)="updateStoreDetails(storeForm.value)" *ngIf="store_details" [disabled]="!storeForm.valid">Update</button>
            <a class="cursor-pointer pull-right mt-1 mr-2" (click)="closeModal()">Cancel</a>
          </div> 
        </div>
      </form>  
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/platform/organisation/store-mgmt/save-store-data/save-store-data.component.html